module.exports = __webpack_public_path__ + "img/ppt.68dc6189.svg";